import styled from "styled-components";

const Main = styled.div`
  display: flex;
  justify-content: center;
`;
export default Main;
